import React from 'react';

import { Feature } from '@models/feature';
import { WidgetApi } from '@utils/widget-api';
import { useWidgetModelContext } from '@utils/widget-model';

import { FeatureUserExplanationDisplay } from '../../../../feature/feature-user-explanation';
import { FeatureExplanation } from '../../../../feature/feature-explanation/FeatureExplanation';
import {
  explanationToUserExplanation,
  FeatureUserExplanationEditor,
} from '../../../../feature/feature-user-explanation';
import { ActionFooter } from '../../../../components/ActionFooter';

export const FeatureLeaderboardUserExplanationEditor = (props: {
  feature: Feature;
  onClose: () => void;
}) => {
  const Widget = WidgetApi.init(useWidgetModelContext());
  const [userExplanation, setUserExplanation] = React.useState(
    props.feature.user_explanation ||
      explanationToUserExplanation(props.feature.explanation.tokens)
  );

  return (
    <div style={{ display: 'flex' }}>
      <FeatureUserExplanationEditor
        userExplanation={userExplanation}
        onUserExplanationChange={setUserExplanation}
      />
      <ActionFooter
        primaryButton={{ label: 'Save' }}
        tertiaryButton={{ label: 'Cancel' }}
        onTertiaryButtonClick={props.onClose}
        onPrimaryButtonClick={() => {
          Widget.callMethod('set_user_explanation', {
            id: props.feature.id,
            user_explanation: userExplanation,
          })
            .then(() => props.onClose())
            .catch(e => console.error(e));
        }}
      />
    </div>
  );
};

export const FeatureLeaderboardEntryExplanation = (props: {
  isEdited: boolean;
  feature: Feature;
  onClose: () => void;
}) => {
  return (
    <div style={{ flex: '1 0 auto' }}>
      {props.isEdited ? (
        <FeatureLeaderboardUserExplanationEditor {...props} />
      ) : props.feature.user_explanation ? (
        <FeatureUserExplanationDisplay
          userExplanation={props.feature.user_explanation}
        />
      ) : (
        <FeatureExplanation
          explanationBlocks={props.feature.explanation.tokens}
        />
      )}
    </div>
  );
};
